import { OrganizationGrid } from "../../components/OrganizationGrid";

// My Organizations — the organizations the signed-in user belongs to, shown as
// cards. Clicking one switches the session into that organization. Available to
// every org role (owner / admin / manager / employee).
const MyOrganizations = () => (
  <div className="dashboard">
    <section className="panel">
      <div className="panel__head">
        <div>
          <h2>My Organizations</h2>
        </div>
      </div>
      <div className="panel__body">
        <OrganizationGrid />
      </div>
    </section>
  </div>
);

export default MyOrganizations;
